import { useContext } from "react"
import { Button, SemanticCOLORS } from "semantic-ui-react"
import { Action } from "../Actions"
import { TaskIdContext } from "./ObjectStateComponent"
import { MissionContext } from "./MissionWorkflowComponent"
import { MissionWorkflowType } from "../Types"
import { UiComponentContext } from "./MissionWorkflowComponent"
import { Mission2ViewContext } from "./TempWrapper"
import { createTestids } from "@famiprog-foundation/tests-are-demo";

const w = window as any

export const buttonComponentTestids = createTestids("ButtonComponent", {
    button: "",
});

export const ButtonComponent = (props: { name: string, actions: Action[], color?: SemanticCOLORS, id: number }) => {
    const { mission } = useContext(MissionContext)
    const { taskId } = useContext(TaskIdContext)
    const { mission2View } = useContext(Mission2ViewContext)
    const { setUiComponent } = useContext(UiComponentContext);
    const label = getLabel(props.id)

    const actions: Action[] = []
    const buttonActionWithUi: Action[] = []

    // Seperate ButtonActionWithUi from actions because they won't be handled the same way
    props.actions.map(action => {
        if (action.constructor.name === "ButtonActionWithUi") {
            buttonActionWithUi.push(action)
        } else {
            actions.push(action)
        }
    })
    return (
        <>
            <Button data-testid={buttonComponentTestids.button + "_" + props.id} color={props.color ? props.color : "blue"}
                onClick={() => {
                    // create an event cf. old logic (discovered by putting breakpoint)
                    // you will need to pass somehow the actions
                    mission2View.executeEventDescriptor(actions, label)
                    buttonActionWithUi.forEach(action => action.run(mission, taskId, setUiComponent))
                }
                }>{label}</Button>
        </>
    );
}

function getLabel(id: number) {
    const localMissionWorkflowTypes: MissionWorkflowType[] = JSON.parse(w.XopsLocalStorage.getItem(`MissionWorkflowTypes`) || 'null');
    const index = localMissionWorkflowTypes.findIndex((data) => data.id === id)
    if (index !== -1) {
        return localMissionWorkflowTypes[index].name
    } else {
        return "Cannot find button name"
    }
}